export const MedCenter_API = {
  organizationHistory: { uploadCSV },
  allPatients: { updatePatient }
}


function updatePatient(userId,patientId) {
  return { api: `/api/v2/medCenters/${userId}/patients/${patientId} `, method: 'PUT' }
}


function uploadCSV(userId,orgId, verCenterId, historyId) {

  return {
    api: `/api/v2/medCenters/${userId}/verifications/${verCenterId}/organizations/${orgId}/histories/${historyId}`,
    method: 'POST'
  }
}
